import React, { FC, useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data } from './TradeHistoryTableLists'
import { useRest } from '../../../../components/Context'
import { TableSmall } from '../../../../components/Dashboard/TableSmall'
import { routes } from '../../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  table: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(4, 4, 2, 4),
    background: 'rgb(49,52,58)',
    textAlign: 'center',
  },
}))
interface TradeHistorySectionProps {
  title: string
  idSf: string
}

export const TradeHistory: FC<TradeHistorySectionProps> = ({ title, idSf }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const history = useHistory()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  // eslint-disable-next-line
  const goTo = useCallback((id: string | number | undefined) => {
    // redirect to ViewAllTrades page by id
  }, [])

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth.get(`${data.request}/${idSf}?page=${page}&count=3`).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setValues(next)

          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error)
          setLoading(false)
        },
        () => {
          setLoading(false)
        },
      )
      cleanupFunction = true
    },
    // eslint-disable-next-line
    [history, rxiosAuth, idSf],
  )

  useEffect(() => {
    if (idSf) {
      ;(async () => {
        await loadData('1')
      })()
    }
  }, [loadData, idSf])

  return (
    <Grid item xs={12} className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} className={classes.container}>
          <Typography variant={'h6'}>{title}</Typography>
        </Grid>

        <Grid item xs={12} className={classes.table}>
          <TableSmall
            columns={data.columns}
            data={values.items}
            params={values.meta}
            // eslint-disable-next-line
            loadData={(pageNumber: any) => loadData(pageNumber)}
            getId={goTo}
            viewAll
            viewAllLink={routes.VIEW_ALL_TRADES_BY_ID.replace(':id', idSf)}
            pb={-1}
            loading={loading}
          />
        </Grid>
      </FormProvider>
    </Grid>
  )
}
